import React from "react";
import "./index.scss";

const Stepper = ({ currentStep }) => {
  return (
    <div className="stepper-container d-flex justify-content-center align-items-end">
      <div className={`step-number ${currentStep === 1 ? "active" : ""}`}>1.</div>
      <div className="step-line" />
              <div className={`step-dot ${currentStep === 1 ? "active" : ""}`}>.</div>
        <div className={`step-number ${currentStep === 2 ? "active" : ""}`}>2.</div>

            <div className="step-line"/>      <div className={`step-dot ${currentStep === 2 ? "active" : ""}`}>.</div> <div className={`step-number ${currentStep === 3 ? "active" : ""}`}>3.</div>

    </div>
  );
};

export default Stepper;
